import PropTypes from 'prop-types';
import { getExchangeVariant, setStoredVariant, VARIANTS } from '../../utils/exchangeVariant';
import { isBranchDeploy } from '../../utils/devTools';
import { devPillStyle } from './debugPillStyle';

/**
 * The dev pill row that sits IN the People header, beside the title (user
 * design 2026-08-20 — mockup: two light grey pills between "People" and the
 * avatar).
 *
 * They used to be black pills fixed to the bottom corners, floating over the
 * page's own content — the variant pill landed on top of the QR pitch card.
 * Chrome that overlaps the thing it is there to help you look at is the wrong
 * shape for the job. In the header they are quiet, they are out of the layout's
 * way, and they read as status rather than as buttons the app wants pressed.
 *
 * Gating is the CALLER's job (isDevToolsEnabled) with one exception owned here:
 * LOC is branch-only, because the location diagnostic is a dev instrument and
 * the user explicitly does not want it on main. The variant pill has no such
 * limit — testing variants on main is the entire reason the gate moved off
 * REACT_APP_BRANCH.
 */
const DevToolsPills = ({ onLocClick }) => {
  const active = getExchangeVariant();

  // Cycles chat → card → text → thread, writes the device store (one of its
  // exactly-two writers), then navigates. Order is VARIANTS itself, so seating
  // a new variant needs no edit here.
  const handleCycleVariant = () => {
    const next = VARIANTS[(VARIANTS.indexOf(active) + 1) % VARIANTS.length];
    setStoredVariant(next);
    // Navigate with any ?v= stripped rather than a bare reload — a tag still in
    // the URL outranks the store on the next load, which would make the pill
    // look dead when it had in fact written.
    const params = new URLSearchParams(window.location.search);
    params.delete('v');
    const search = params.toString();
    window.location.href = `${window.location.pathname}${search ? `?${search}` : ''}`;
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
      <button onClick={handleCycleVariant} style={devPillStyle} aria-label={`Variant: ${active}`}>
        {active.toUpperCase()}
      </button>
      {isBranchDeploy() && (
        <button onClick={onLocClick} style={devPillStyle} aria-label="Location diagnostic">
          LOC
        </button>
      )}
    </div>
  );
};

DevToolsPills.propTypes = {
  onLocClick: PropTypes.func,
};

export default DevToolsPills;
